import React from 'react';
import {createStore} from 'redux'

// ------------------------------------------------------------------------------------------------------------------ //
// Redux reducer
// ------------------------------------------------------------------------------------------------------------------ //
export const FrontendLandingPageReducer = createStore( function (state = {

}, action)
{
    console.log("[FRONTEND_LANDING_PAGE_APP] "+action.type);

    switch (action.type)
    {
    }

    return state;
});
